import request from '../../utils/request'
//获取验证码

//系统头像展示
export function showDefaultImg(){
    return request({
        url:'/auth/personal/headImgShow',
        method: 'get',
    })
}

//微信绑定后同步头像
export function getWechatImg(){
    return request({
        url:'/auth/personal/followWechatHeadImgSetting',
        method: 'get',
    })
}

//验证原手机号
export function checkVerificationCode(data) {
    return request({
        url: '/auth/personal/checkVerificationCode',
        method: 'post',
        data
    })
}

//新增备用手机号,修改 主/备手机号
export function changeMobile(data) {
    return request({
        url: '/auth/personal/changeMobile',
        method: 'post',
        data
    })
}
//修改备用手机号
// /auth/account/personalVerificationCode
export function personalVerificationCode(data) {
    return request({
        url: '/auth/account/personalVerificationCode',
        method: 'post',
        data
    })
}

//获取基础信息
export function getBase(data) {
    return request({
        url: '/auth/personal/accountInfo',
        method: 'post',
    })
}

//保存 头像 wechat QRcode
export function saveBase(data) {
    return request({
        url: '/auth/personal/saveFaceUrl',
        method: 'post',
        data
    })
}


//首页设置
//查询
export function getIndex(id) {
    return request({
        url: `/auth/personal/queryIndexUrl?systemType=${id}`,
        method: 'get',
    })
}
//设置
export function setIndex(data) {
    return request({
        url: `/auth/personal/loginIndexPageSetting`,
        method: 'post',
        data
    })
}

//业务规则
export function queryBusinessRules() {
    return request({
        url: `/auth/personal/queryBusinessRules`,
        method: 'post',
    })
}

//我的团队
//1.团队列表
export function queryMyTeam(data) {
    return request({
        url: `/auth/personalCenter/conditionMyTeam`,
        method: 'post',
        data
    })
}
//禁用申请
export function disableApply(data) {
    return request({
        url: '/auth/personalCenter/disableApply',
        method: 'post',
        data
    })
}

//启用申请
export function enableApply(data) {
    return request({
        url: '/auth/personalCenter/enableApply',
        method: 'post',
        data
    })
}

//冻结申请
export function frozenApply(data) {
    return request({
        url: '/auth/personalCenter/frozenApply',
        method: 'post',
        data
    })
}

//解冻申请
export function unfrozenApply(data) {
    return request({
        url: '/auth/personalCenter/unfrozenApply',
        method: 'post',
        data
    })
}

//查询系统是否被锁
export function queryLookStatus(data) {
    return request({
        url: '/auth/account/queryLookStatus',
        method: 'post',
        data
    })
}

//修改平级销售团队订单是否需要审核
export function editLevelSalesAudit(data) {
    return request({
        url: '/auth/shopowner/editLevelSalesAudit',
        method: 'post',
        data
    })
}
//修改自由销售人微信入账开关
export function editWxEntrySwitch(data) {
    return request({
        url: '/auth/shopowner/editWxEntrySwitch',
        method: 'post',
        data
    })
}
//查询自由销售人微信入账开关
export function getWxEntrySwitch(data) {
    return request({
        url: '/auth/shopowner/getWxEntrySwitch',
        method: 'get'
    })
}

//查询 平级销售 团队订单是否需要审核
export function getLevelSalesAudit(id) {
    return request({
        url: `/auth/shopowner/getLevelSalesAudit`,
        method: 'get',
    })
}

// 查询团队内平级销售数量与二级销售数量
export function queryTeamSales(id) {
    return request({
        url: `/auth/shopowner/queryTeamSales`,
        method: 'get',
    })
}


// WEBPACK FOOTER //
// ./src/TASMini/api/person.js